import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

/**
 * Particles为例子特效组件，在vue3+ts项目中使用（yarn add @tsparticles/vue3）
 * 参考代码git地址：https://github.com/tsparticles/vue3
*/
import Particles from '@tsparticles/vue3'
/**
 * 基于 tsparticles 引擎(npm install @tsparticles/slim / npm install tsparticles-slim)
*/
import { loadSlim } from '@tsparticles/slim'
import './assets/style/banner.css'
import './assets/style/normalize.scss'
import './assets/style/global.css'
;
// 字体图标资源
// import './assets/iconFonts/iconfont.css'
// import './assets/iconFonts/iconfont-footer.css'

const app = createApp(App);

app.use(store);

app.use(router);

app.use(ElementPlus);

app.use(Particles, {
  init: async engine => {
    await loadSlim(engine)
  }
});

// createApp(App).use(ElementPlus).use(store).use(router).use(Particles, {
//   init: async engine => {
//     await loadSlim(engine)
//   }
// }).mount('#app')

app.mount("#app");
